import {
  DispatchFreightContext,
  DispatchPreferredRateMethod,
} from '../models/dispatch-freight.models';

export interface FreightmancerDispatchSource {
  customerUuid: unknown;
  shipperUuid: unknown;
  shipperAddressUuid: unknown;
  shipperPostalCode: unknown;
  consigneeUuid: unknown;
  consigneeAddressUuid: unknown;
  consigneePostalCode: unknown;
  rateMethod: unknown;
}

export interface FreightmancerDispatchBridge {
  context: DispatchFreightContext;
  preferredRateMethod: DispatchPreferredRateMethod | null;
}

/**
 * The only Freightmancer-specific mapping in the shared feature. It accepts
 * primitives from the operational forms and never imports the CRQ component.
 */
export function adaptFreightmancerDispatch(
  source: FreightmancerDispatchSource,
): FreightmancerDispatchBridge {
  return {
    context: {
      customer_contact_uuid: cleanString(source.customerUuid) || undefined,
      origin: compactLocation(
        source.shipperPostalCode,
        source.shipperUuid,
        source.shipperAddressUuid,
      ),
      destination: compactLocation(
        source.consigneePostalCode,
        source.consigneeUuid,
        source.consigneeAddressUuid,
      ),
    },
    preferredRateMethod: preferredRateMethod(source.rateMethod),
  };
}

function compactLocation(
  postalCodeValue: unknown,
  contactUuidValue: unknown,
  addressUuidValue: unknown,
): DispatchFreightContext['origin'] {
  const location: DispatchFreightContext['origin'] = {};
  const postalCode = cleanString(postalCodeValue).toUpperCase();
  const contactUuid = cleanString(contactUuidValue);
  const addressUuid = cleanString(addressUuidValue);

  if (postalCode) location.postal_code = postalCode;
  if (contactUuid) location.contact_uuid = contactUuid;
  if (addressUuid) location.contact_address_uuid = addressUuid;
  return location;
}

function preferredRateMethod(value: unknown): DispatchPreferredRateMethod | null {
  switch (cleanString(value)) {
    case '1': return 1;
    case '2': return 2;
    case '3': return 3;
    case '4': return 4;
    default: return null;
  }
}

function cleanString(value: unknown): string {
  return typeof value === 'string' ? value.trim() : '';
}
